import {
  PAYMENT_INTEGRITY_DETAILS_REQUEST,
  PAYMENT_INTEGRITY_DETAILS_SUCCESS,
  PAYMENT_INTEGRITY_DETAILS_FAILURE,
  PAYMENT_INTEGRITY_DETAILS_LOADING,
} from '../actionTypes';

export const fetchPaymentIntegrityDetailsRequest = (payload: any) => ({
  type: PAYMENT_INTEGRITY_DETAILS_REQUEST,
  payload
});

export const fetchPaymentIntegrityDetailsSuccess = (payload: any) => ({
  type: PAYMENT_INTEGRITY_DETAILS_SUCCESS,
  payload
});

export const fetchPaymentIntegrityDetailsError = (payload: any) => ({
  type: PAYMENT_INTEGRITY_DETAILS_FAILURE,
  payload
});

export const isLoadingDetails = (payload: boolean) => ({
  type: PAYMENT_INTEGRITY_DETAILS_LOADING,
  payload
});